module.exports = __webpack_public_path__ + "img/heart.862d98bb.png";